import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Weather.css";

const API_BASE = process.env.NODE_ENV === "development"
  ? "https://arecah.com/weather/api"
  : "/weather/api";

/* Background images from backup - full-screen cover with dark overlay */
const WEATHER_BG = {
  Clear: "linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.5)), url(/images/weather/clear-sky.jpg) center/cover no-repeat",
  Clouds: "linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.5)), url(/images/weather/clouds.jpg) center/cover no-repeat",
  Rain: "linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.5)), url(/images/weather/rain.jpg) center/cover no-repeat",
  Drizzle: "linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.5)), url(/images/weather/clouds.jpg) center/cover no-repeat",
  Thunderstorm: "linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.6)), url(/images/weather/rain.jpg) center/cover no-repeat",
  Snow: "linear-gradient(135deg, #E5E7EB 0%, #F3F4F6 100%)",
  default: "linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.5)), url(/images/weather/default.jpg) center/cover no-repeat",
};

function Weather() {
  const [city, setCity] = useState("");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!city.trim()) return;
    setError(null);
    setData(null);
    setLoading(true);

    try {
      const res = await fetch(`${API_BASE}/fetch_weather.php?q=${encodeURIComponent(city.trim())}`);
      const json = await res.json();

      if (json.error) {
        setError(json.error);
        setData(null);
      } else {
        setData(json);
      }
    } catch (err) {
      setError(err.message || "Failed to fetch weather");
      setData(null);
    } finally {
      setLoading(false);
    }
  };

  const bgStyle = data?.weather?.[0]?.main
    ? WEATHER_BG[data.weather[0].main] || WEATHER_BG.default
    : WEATHER_BG.default;

  return (
    <div className="weather" style={{ background: bgStyle }}>
      <header className="weather-header">
        <Link to="/" className="back-link">← Arecah</Link>
        <h1>Weather</h1>
        <p>Get weather for major cities worldwide.</p>
      </header>

      <div className="weather-content">
        <form onSubmit={handleSubmit} className="weather-form">
          <input
            type="text"
            value={city}
            onChange={(e) => setCity(e.target.value)}
            placeholder="Enter city name (e.g. Sydney, London)"
            className="weather-input"
          />
          <button type="submit" disabled={loading} className="weather-btn">
            {loading ? "Loading…" : "Search"}
          </button>
        </form>

        {error && <div className="weather-error">{error}</div>}

        {data && !loading && (
          <div className="weather-card">
            <h2>{data.name}, {data.sys?.country}</h2>
            <p className="weather-desc">{data.weather?.[0]?.description}</p>
            <p className="weather-temp">{Math.round(data.main?.temp)}°C</p>
            <div className="weather-details">
              <span>Feels like {Math.round(data.main?.feels_like)}°C</span>
              <span>Humidity {data.main?.humidity}%</span>
              <span>Wind {data.wind?.speed} m/s</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Weather;
